export function isData2D(data) {
    return ('rr' in data ||
        (!('x' in data) && 're' in data));
}
//# sourceMappingURL=isData2D.js.map